export default { title: 'Subir reseña de Google' };
